// extracted by mini-css-extract-plugin
export default {"container":"CustomMoodboardPicture_container__RmdR2","editMode":"CustomMoodboardPicture_editMode__k-YKd"};